import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import * as sdkTypes from '@vansite/ts-sharetribe-flex-sdk/types';
import Decimal from 'decimal.js';
import React from 'react';
import { useIntl } from 'react-intl';

import { formatMoney } from '../../../util/currency';
import { FormattedMessage } from '../../../util/reactIntl';
import { LINE_ITEM_CUSTOMER_COMMISSION, LINE_ITEM_CUSTOMER_COMMISSION_EXTRA_LINE_ITEMS } from '../../../util/types';
import { itemValueStyles, lineItemStyles } from './BookingBreakdown.styles';

const { Money } = sdkTypes;

/**
 * @param {object} props
 * @param {object} props.transaction
 * @param {boolean} props.isCustomer
 */

const LineItemCustomerCommissionRefundMaybe = ({ transaction, isCustomer }) => {
  const intl = useIntl();

  if (!isCustomer) return null;

  const customerCommissionLineItem = transaction.attributes.lineItems.find(
    (item) => item.code === LINE_ITEM_CUSTOMER_COMMISSION && item.lineTotal.amount < 0,
  );

  const customerCommissionExtraLineItem = transaction.attributes.lineItems.find(
    (item) =>
      item.code === LINE_ITEM_CUSTOMER_COMMISSION_EXTRA_LINE_ITEMS && item.lineTotal.amount < 0,
  );

  if (isCustomer && !customerCommissionLineItem) {
    return null;
  }

  const commissionAmount =
    (customerCommissionLineItem?.lineTotal.amount || 0) +
    (customerCommissionExtraLineItem?.lineTotal.amount || 0);

  const formattedCommission = formatMoney(
    intl,
    new Money(
      new Decimal(commissionAmount).round().toNumber(),
      customerCommissionLineItem?.lineTotal.currency ||
      customerCommissionExtraLineItem?.lineTotal.currency,
    ),
  );

  return (
    <Box sx={lineItemStyles}>
      <Typography sx={{ flex: 1 }} variant="lineItemLabel">
        <FormattedMessage id="BookingBreakdown.refundCustomerFee" />
      </Typography>
      <Typography sx={itemValueStyles} variant="lineItemLabel">{formattedCommission}</Typography>
    </Box>
  );
};

export default LineItemCustomerCommissionRefundMaybe;
